import { observer } from "mobx-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { AuthenticatorPage } from "./AuthenticatorPage";
import { PublicScope } from "../../auth/models/PublicCredentials";
import { ProjectApi } from "../../project/services/ProjectApi";
import { MapPage } from "./MapPage";

export const SharedProjectMapPage = observer(() => {
  const { projectId } = useParams();
  const [validated, setValidated] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);

  if (validated) return <MapPage isShared />;

  return (
    <AuthenticatorPage
      scope={PublicScope.Project}
      scopeId={projectId ?? ""}
      isInvalid={isInvalid}
      onSubmit={() =>
        ProjectApi.validatePassword(projectId!)
          .then(() => setValidated(true))
          .catch(() => setIsInvalid(true))
      }
    />
  );
});
